export default {"src":"/_next/static/media/square-dark.77d4f157.svg","height":386,"width":386,"blurWidth":0,"blurHeight":0};